import { clearState } from './Filters/filtersReducer';
import {
  EXPERTS_LOADED,
  EXPERT_PROJECT_CLICKED,
  PAGE_CHANGED,
  SET_PAGE_COUNT,
  EXPERTS_LOADING,
  HIDE_LOADING,
  INITIAL_FILTERS_LOADED_FROM_URL,
  FILTERS_VALIDATION_TOGGLE,
} from './exploreActionTypes';
import { PAGINATION_PAGE_SIZE } from '../../utils/constants';

export const initialState = {
  urlFilters: { ...clearState },
  experts: [],
  total: 0,
  pagination: {
    page: 1,
    pageSize: PAGINATION_PAGE_SIZE,
    pageCount: 1,
  },
  loading: true,
  isFiltersValid: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EXPERTS_LOADING:
      return {
        ...state,
        loading: true,
        isFiltersValid: true,
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: false,
      };
    case EXPERTS_LOADED:
      return {
        ...state,
        experts: action.experts,
        total: action.total,
        loading: false,
      };
    case PAGE_CHANGED:
      return {
        ...state,
        pagination: { ...state.pagination, page: action.page },
      };
    case SET_PAGE_COUNT:
      return {
        ...state,
        pagination: { ...state.pagination, pageCount: action.pageCount },
      };
    case INITIAL_FILTERS_LOADED_FROM_URL: {
      const tempPage = Number(action.urlParams.page);
      const page = !isNaN(tempPage) && tempPage > 0 ? tempPage : 1;
      delete action.urlParams.page;
      return {
        ...state,
        urlFilters: { ...clearState, ...action.urlParams },
        pagination: {
          ...state.pagination,
          page,
        },
      };
    }
    case FILTERS_VALIDATION_TOGGLE:
      return {
        ...state,
        isFiltersValid: action.isFiltersValid,
      };
    case EXPERT_PROJECT_CLICKED:
    default:
      return state;
  }
};
